import { useQuery } from "react-query";
import { getImageCompareAttributeGroups } from "components/duplicate-staging/lib/productData";

export const useGetImageCompareAttributeGroups = () => {
    return useQuery({
        queryKey: ["imageCompareAttributeGroups"],
        queryFn: () => getImageCompareAttributeGroups(),
    });
};
